var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Multiselect',{attrs:{"label":"displayName","track-by":"url","disabled":_vm.isDisabled,"options":_vm.calendars,"value":_vm.value,"multiple":_vm.multiple},on:{"select":_vm.change,"remove":_vm.remove},scopedSlots:_vm._u([{key:"singleLabel",fn:function(ref){
var option = ref.option;
return [_c('CalendarPickerOption',_vm._b({},'CalendarPickerOption',option,false))]}},{key:"option",fn:function(ref){
var option = ref.option;
return [_c('CalendarPickerOption',_vm._b({},'CalendarPickerOption',option,false))]}},{key:"tag",fn:function(ref){
var option = ref.option;
return [_c('div',{staticClass:"calendar-picker__tag"},[_c('CalendarPickerOption',_vm._b({},'CalendarPickerOption',option,false))],1)]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }